module.exports = __webpack_public_path__ + "static/media/placeholder.cfc4da78.png";